import script from "./TransactionConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionConfirm.vue?vue&type=script&setup=true&lang=js"

import "./TransactionConfirm.vue?vue&type=style&index=0&id=2993b188&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2993b188"]])

export default __exports__